function normalizeOpenAiBaseUrl(url) {
    if (!url) {
        return '';
    }
    const normalizedUrl = url.trim().replace(/\/+$/, '').replace(/(?:\/v1)+$/, '');
    if (!normalizedUrl) {
        return '';
    }
    return normalizedUrl;
}
export function getSdkOpenAiBaseUrl(url) {
    const normalizedUrl = normalizeOpenAiBaseUrl(url);
    return normalizedUrl ? `${normalizedUrl}/v1` : '';
}
